"use client";

import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { useTranslations } from "next-intl";
import { useAuthDialogStore } from "@/features/user/ui/store";
import { AnalyticsEvents, trackEvent } from "@/lib/client/analytics/product-analytics";
import { useSession } from "@/lib/client/auth/client";
import { CountrySelector } from "@/lib/client/components/CountrySelector";
import { useGreetingStore } from "@/lib/client/stores/useGreetingStore";
import { Button, Dialog, DialogContent, DialogTitle, HStack, Text, VStack } from "@/ui";

export const GreetingModal = () => {
  const { data: session } = useSession();
  const { toggleAuthDialog } = useAuthDialogStore();
  const greetingT = useTranslations("greeting");
  const { showGreeting, setShowGreeting } = useGreetingStore();
  const onRegisterClick = () => {
    trackEvent(AnalyticsEvents.GREETING_REGISTER_CLICKED);
    toggleAuthDialog(true);
    setShowGreeting(false);
  };

  const handleClose = () => {
    trackEvent(AnalyticsEvents.GREETING_MODAL_CLOSED);
    setShowGreeting(false);
  };

  return (
    <Dialog
      modal={false}
      open={showGreeting}
      onOpenChange={setShowGreeting}
    >
      <DialogContent
        aria-label={greetingT("title")}
        className="max-h-none p-0 sm:max-w-3xl"
        data-testid="greeting-modal"
      >
        <VisuallyHidden.Root>
          <DialogTitle>{greetingT("title")}</DialogTitle>
        </VisuallyHidden.Root>
        <VStack className={"items-center justify-evenly space-y-6 px-4 py-8 md:px-8"}>
          <VStack className={"space-y-2"}>
            <Text className={"text-center font-serif text-2xl font-bold"}>
              {greetingT("title")}
            </Text>
            <Text className={"text-center font-serif text-lg"}>{greetingT("description")}</Text>
          </VStack>

          <VStack className={"w-full space-y-2"}>
            {!session?.user && (
              <>
                <HStack className={"justify-center space-x-2"}>
                  <Button
                    variant={"outline"}
                    data-testid="greeting-continue"
                    onClick={handleClose}
                  >
                    {greetingT("continue")}
                  </Button>
                  <Button
                    variant={"default"}
                    onClick={onRegisterClick}
                  >
                    {greetingT("register")}
                  </Button>
                </HStack>
                <Text className={"text-center font-sans text-sm text-foreground/75"}>
                  {greetingT("register_description")}
                </Text>
              </>
            )}
            <HStack className={"w-full items-center justify-between space-x-2"}>
              <Text>{greetingT("ship_to")}</Text>
              <CountrySelector />
            </HStack>
          </VStack>
        </VStack>
      </DialogContent>
    </Dialog>
  );
};
